module.exports = __webpack_public_path__ + "img/vertical_4_7_8023.752cf424.png";